import { batch } from "react-redux";

import { isCompleteFill, updateActiveMenu } from "@/actions/setupActions";
import { VOLUME_SENSOR_CHART } from "@/constants/pcConstAppData";
import {
  DataType,
  GetLatestVolumeSensor,
  getVolumeSensor,
  getVolumeSensorChart,
} from "@/contents/volumeSensorChart/data/volumeSensorDataSource";
import { isAllAutoProfileParamFilled } from "@/libs/appHelper";

// eslint-disable-next-line import/prefer-default-export
export const getDataSensor = (displayedData) => async (dispatch, getState) => {
  let response = [];
  try {
    const { autoProfileState } = { ...getState() };
    const { runningMethod } = autoProfileState;

    response = await GetLatestVolumeSensor(
      displayedData,
      DataType.Percentage,
      runningMethod
    );
  } catch (error) {
    console.log("getDataSensor error", error);
  }

  return response;
};

export const getAutoProfileGraph =
  (isInitialState = false) =>
  async (dispatch, getState) => {
    let response = [];
    try {
      const { autoProfileState, setupStore } = { ...getState() };
      const { runningMethod } = autoProfileState;
      const { currentAdvSetupParams } = setupStore;
      const highVolumeBuffer =
        currentAdvSetupParams?.ConfigAdvSetup?.GeneralAdvSetup
          ?.HighVolumeBufferFlag;

      response = isInitialState
        ? await getVolumeSensorChart(runningMethod, highVolumeBuffer)
        : await getVolumeSensor(runningMethod);
    } catch (error) {
      console.log("getDataSensor error", error);
    }

    return response;
  };

export const initAutoProfileGraph = () => async (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const { currentProfileParams } = setupStore;

  batch(() => {
    dispatch(
      isCompleteFill(isAllAutoProfileParamFilled(currentProfileParams) === true)
    );
    dispatch(updateActiveMenu(VOLUME_SENSOR_CHART));
  });

  const response = await dispatch(getAutoProfileGraph(true));

  return response;
};
